import { UnicodeConverter } from './unicodeConverter';

export class LinkedInFormatter {
  /**
   * Convert HTML to LinkedIn-compatible plain text
   * - Preserve line breaks and spacing
   * - Convert lists to bullet points (•) or numbers
   * - Convert headings to UPPERCASE
   * - Clean up excessive whitespace
   */
  static convertToLinkedInFormat(html: string): string {
    const parser = new DOMParser();
    const doc = parser.parseFromString(html, "text/html");
    return this.processNode(doc.body).trim();
  }

  private static processNode(node: Node): string {
    if (node.nodeType === Node.TEXT_NODE) {
      return node.textContent || "";
    }

    if (node.nodeType !== Node.ELEMENT_NODE) {
      return "";
    }

    const element = node as HTMLElement;
    let content = "";
    
    // Process child nodes
    element.childNodes.forEach((child) => {
      content += this.processNode(child);
    });

    switch (element.tagName.toLowerCase()) {
      case "p":
      case "div":
        return content + "\n";
      case "br":
        return "\n";
      case "h1":
      case "h2":
      case "h3":
      case "h4":
      case "h5":
      case "h6":
        return "\n" + content.toUpperCase() + "\n";
      case "li":
        const parent = element.parentElement;
        if (parent?.tagName.toLowerCase() === "ol") {
            // Very simple numbering approximation, ideally we'd track index
            // But getting index in recursive tree is tricky without state.
            // For now, let's just use a generic number or bullet if complex.
            // A better approach is to check previous siblings.
            let index = 1;
            let sibling = element.previousElementSibling;
            while(sibling) {
                if(sibling.tagName.toLowerCase() === 'li') index++;
                sibling = sibling.previousElementSibling;
            }
            return index + ". " + content + "\n";
        }
        return "• " + content + "\n";
      case "ul":
      case "ol":
        return "\n" + content + "\n";
      case "strong":
      case "b":
        return UnicodeConverter.toBold(content);
      case "em":
      case "i":
        return UnicodeConverter.toItalic(content);
      case "u":
        return UnicodeConverter.toUnderline(content);
      default:
        return content;
    }
  }

  /**
   * Optimize spacing for LinkedIn posts
   */
  static optimizeSpacing(text: string): string {
    return text
      .replace(/\n{3,}/g, "\n\n") // Max 2 consecutive line breaks
      .trim();
  }
}
